import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import * as RiderAuthenticationActions from '@uzurv/rideWss/app/store/rider-authentication/rider-authentication.action';
import * as RiderAuthenticationSelectors from '@uzurv/rideWss/app/store/rider-authentication/rider-authentication.selector';
import * as PaymentSelectors from '@uzurv/rideWss/app/store/payment/payment.selectors';
import * as RidesSelectors from '@uzurv/rideWss/app/store/rides/rides.selectors';

@Injectable({ providedIn: 'root' })
export class AppFacade {
  // RiderAuthentication
  readonly authenticationStatus$ = this.store$.select(RiderAuthenticationSelectors.getAuthenticationStatus);
  readonly isRiderSuspended$ = this.store$.select(RiderAuthenticationSelectors.getIsRiderSuspended);

  // Payment
  readonly outstandingCharges$ = this.store$.select(PaymentSelectors.getOutstandingCharges);

  // Rides
  readonly isRiderEligible$ = this.store$.select(RidesSelectors.isRiderEligible);
  readonly isCreateRideEnabled$ = this.store$.select(RidesSelectors.getIsCreateRideEnabled);
  readonly isInitialOrganizationRiderListItemsLoaded$ = this.store$.select(RidesSelectors.getIsInitialOrganizationRiderListItemsLoaded);
  readonly selectedOrganizationRiderListItem$ = this.store$.select(RidesSelectors.getSelectedOrganizationRiderListItem);

  // Facade Selectors
  readonly isRiderIneligible$: Observable<boolean> = combineLatest([
    this.isRiderSuspended$,
    this.outstandingCharges$,
    this.isRiderEligible$,
    this.isCreateRideEnabled$
  ]).pipe(
    map(
      ([isRiderSuspended, outstandingCharges, isRiderEligible, isCreateRideEnabled]): boolean =>
        isRiderSuspended || outstandingCharges?.length > 0 || !isRiderEligible || !isCreateRideEnabled
    )
  );

  // Facade Actions
  rehydrateState(): void {
    this.store$.dispatch(RiderAuthenticationActions.rehydrateState());
  }

  logout(): void {
    this.store$.dispatch(RiderAuthenticationActions.logout());
  }

  navigateToPage(page: string): void {
    this.router.navigate([page]);
  }
  constructor(private store$: Store, private router: Router) {}
}
